import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from '../../Header';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class ViewLeaveReward extends Component {
  constructor() {
    super();
    var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
    var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
    this.state = {
      leaves: [],
      rewards: [],
      employee: '',
      apiUrl: this.decryptconfigdata('apiUrl'),
      userAuthKey: has_local_data ? localdata.user_key : '',
      userId: has_local_data ? localdata.user_id : '',
      userEmail: has_local_data ? localdata.user_email : '',
      leave_reward_state: 1,
      startDate: new Date(),
      endDate: new Date(),
    };
        this.handleChangeStart = this.handleChangeStart.bind(this);
        this.handleChangeEnd = this.handleChangeEnd.bind(this);
}

  decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
    var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
      iv
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }

  decrypt(findresponse, flg) {
    var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
    var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
      iv
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  }

  handleChangeStart(date) {
    this.setState({
        startDate: date
    });
}

  handleChangeEnd(date) {
    this.setState({
        endDate: date
    });
}

showLeave() {
    fetch(this.state.apiUrl + '/HrmanagementRest/showLeave/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.props.match.params.employeeId, {
      method: 'POST',
      dataType: 'json',
      body: JSON.stringify(this.state),
  })
  .then((Response) => Response.json())
      .then((findresponse) => {
        findresponse = this.decrypt(findresponse, 1);
      this.setState({
        leaves: findresponse.leaves
      })
  })
}

showReward() {
    fetch(this.state.apiUrl + '/HrmanagementRest/showReward/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.props.match.params.employeeId, {
      method: 'POST',
      dataType: 'json',
      body: JSON.stringify(this.state),
  })
  .then((Response) => Response.json())
      .then((findresponse) => {
        findresponse = this.decrypt(findresponse, 1);
      this.setState({
        rewards: findresponse.rewards
      })
  })
}

leaveRewardBalance() {
    fetch(this.state.apiUrl + '/HrmanagementRest/leaveRewardBalance/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.props.match.params.employeeId, {
      method: 'POST',
      dataType: 'json',
      body: JSON.stringify(this.state),
  })
  .then((Response) => Response.json())
      .then((findresponse) => {
        findresponse = this.decrypt(findresponse, 1);
      this.setState({
          leavesAvailable: findresponse.leaves_available,
          leavestaken: findresponse.leaves_taken,
          lop_cnt: findresponse.lop_cnt,
          advance_leave_cnt: findresponse.advance_leave_cnt,
          rewardsPoints: findresponse.rewards_points,
          attachment: findresponse.attachment,
          attachment_url: findresponse.attachment_url,
          emp_start_name: findresponse.emp_start_name,
          name: findresponse.name,
          position: findresponse.position,
          hr_permission: findresponse.hr_permission,
          leave_earned: findresponse.total_leaves,
          carry_forward_leave_earned: findresponse.carry_forward_leave_earned,
          current_quarter: findresponse.current_quarter,
      });
  });
}

  changeStateLeaveReward() {
    { this.setState({ leave_reward_state: 0 }) }
}

  changeStateRewardLeave() {
    { this.setState({ leave_reward_state: 1 }) }
}

  employee_details() {
    fetch(this.state.apiUrl + '/HrmanagementRest/ViewEmployeeLeaveReward/id/' + this.props.match.params.employeeId + '/userAuthKey/' + this.state.userAuthKey)
      .then((Response) => Response.json())
      .then((responseJson) => {
        responseJson = this.decrypt(responseJson, 1);
          this.setState({
          employee: responseJson.employee
  })
  })
}

  componentDidMount() {
    this.leaveRewardBalance();
    document.title = "Intranet | Leave & Rewards";
    if (!localStorage.getItem('userLogin')) {
      this.setState({ redirect: true });
      }
        this.showLeave();
        this.showReward();
    }

  render() {
    if (this.state.redirect) {
      return (
        <Redirect to={'/login'} />
      )
    }
    if (this.state.hr_permission !== undefined) {
        if(this.state.hr_permission == 'no' && (this.state.userId != this.props.match.params.employeeId)){
            return (
                <Redirect to={'/home'} />
            )
        }
    }
    return (
          <div>
           <Header brecum_name="Leave & Rewards" brecum_page="Leave & Rewards" />
           <div class="right_col">
           <div class="intranet_body">
                    <div class="title mob hidden-sm">
                        <span>Leave & Rewards</span>
                    </div>
                    <div class="top-row">
                    <div class="main_dashborad l_r">
              <div class="pro_image pimage">
                <Link to={`/viewEmployee/${this.props.match.params.employeeId}`} name={"max"}>
                  {this.state.attachment && this.state.attachment_url ? <img src={this.state.attachment_url + this.state.attachment} /> : <span class="profile_first_name">{this.state.emp_start_name}</span>}
               </Link>
              </div>
              <div class="emp_det">
              <h6>
                  <Link to={`/viewEmployee/${this.props.match.params.employeeId}`} name={"max"}>
                {this.state.name ? this.state.name : '--'}
              {/* <button type="button" onClick={()=> this.employee_details(this.state.userId)} class="btn btn-sky" data-toggle="modal" data-target="#Modalreminder" data-dismiss="modal">Apply Leave</button> */}
                 </Link>
              </h6>
              <h5>
                {this.state.position ? this.state.position : '--'}
              </h5>
              </div>
              {this.state.leave_reward_state == 1 ? 
                  <div class="dash lreward">
                    <div class="add_dash"><div class="dash_price Greeen">{this.state.leavesAvailable ? this.state.leavesAvailable : 0}</div><div class="dash_wb">{this.state.leavesAvailable <= 1 ? 'Leave Available' : 'Leaves Available'} {`(Q${this.state.current_quarter || ""})`}</div></div>
                    <div class="add_dash"><div class="dash_price Red">{this.state.leavestaken ? this.state.leavestaken : '--'}</div><div class="dash_wb">{this.state.leavestaken <= 1 ? 'Leave Taken' : 'Leaves Taken'}</div></div>
                    <div class="add_dash"><div class="dash_price Red">{this.state.advance_leave_cnt ? this.state.advance_leave_cnt : 0} / {this.state.lop_cnt ? this.state.lop_cnt : 0}</div><div class="dash_wb">Advance / LOP</div></div>
                    <div class="add_dash"><div class="dash_price Red">{this.state.leave_earned ? this.state.leave_earned : 0} / {this.state.carry_forward_leave_earned ? this.state.carry_forward_leave_earned : 0}</div><div class="dash_wb">Allocated Leaves / Carry Forward</div></div>
                  </div> : 
                  <div class="dash">
                    <div class="add_dash reward"><div class="dash_price">{this.state.rewardsPoints ? this.state.rewardsPoints : 0}</div><div class="dash_wb">{this.state.rewardsPoints <= 1 ? 'Reward Points' : 'Rewards Points'}</div></div>
                  </div>
                }
                
            </div>
            <div id="exTab1" class="container">	
                        <ul  class="nav nav-pills">
                                <li class="active"><a onClick={()=> this.changeStateRewardLeave()} href="#Login" data-toggle="tab">Leave History</a>
                                </li>
                                <li><a onClick={()=> this.changeStateLeaveReward()} href="#Upload" data-toggle="tab">Reward Points</a>
                                </li>
                        </ul>
            
                            <div class="tab-content customer-tab clearfix">
                                <div class="tab-pane active" id="Login">
                                <ul class="tickets_head">
                              <li class="intra_col_30"><p><span>Leave</span><span>Duration</span></p></li>
                              <li class="intra_col_30">Reason</li>
                              <li class="intra_col_10">Day(S)</li>
                              <li class="intra_col_15">Type</li>
                              <li class="intra_col_15">Status</li>
                          </ul>
                          {
                      this.state.leaves.length == 0 ? <div className="text-center" style={{ color: 'red' }}>No Data Found</div> :
                        this.state.leaves.map((user, key) =>
                                <ul class="tickets_number">
                                    <li class="intra_col_30">{user.date + ' - ' + user.to_date}</li>
                            <li class="intra_col_30">{user.note ? <p><div dangerouslySetInnerHTML={{ __html: user.note }} /></p> : '--'}</li>
                            <li class="intra_col_10">{user.days}</li>
                            <li class="intra_col_15">{user.leave_category}</li>
                            <li class="intra_col_15"> {user.status == 'pending' ? <span class="error">Pending</span> : user.status == 'approved' ? <span class="green">Approved</span> : <span class="error">Declined</span>}</li>
                                </ul>
                                 
                                )
                            } 
                                </div>
                                <div class="tab-pane" id="Upload">
                                <ul class="tickets_head">
                              <li class="intra_col_20">Reward Date</li>
                              <li class="intra_col_20">Rewards</li>
                              <li class="intra_col_40">Reason</li>
                          </ul>
                          {
                      this.state.rewards.length == 0 ? <div className="text-center" style={{ color: 'red' }}>No Data Found</div> :
                        this.state.rewards.map((user, key) =>
                                <ul class="tickets_number">
                                    <li class="intra_col_20">{user.date}</li>
                                    <li class={'intra_col_20 '+ (user.is_credited == 2 ? 'text-danger' :'text-success')}> {user.is_credited == 2 ? <i class='fa fa-minus fa-thin text-danger'></i>:<i class='fa fa-plus fa-thin text-success'></i>} {user.credit_reward}</li>
                                    <li class="intra_col_40">{user.note ? <p><div dangerouslySetInnerHTML={{ __html: user.note }} /></p> : '--'}</li>
                                </ul>
                                 
                                )
                            } 
                                </div>
                            </div>                                      
                        </div>
                    </div>
                    </div>
                    </div>
                    
         </div>
        )
      }
}
export default ViewLeaveReward;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/viewLeaveReward.js